import React from 'react';

import { useTranslation } from 'react-i18next';
import LoginLayout from '../components/LoginLayout';
import LoginCard from '../components/LoginCard';
import LoginLineDot from '../components/LoginLineDot';
import Heading from '../../../generic-components/Heading';

import { HELP_SCREEN_DATA } from '../constants';
import { LOGIN_NAVIGATION_MAP } from '../components/LoginNavigation/constants';
import { AUTOMATION_TEST_ID } from '../../../constants/general';

const Help = () => {
  const {
    LOGIN_CARD, HEADING, TEXT, GRID,
  } = HELP_SCREEN_DATA;

  const { t } = useTranslation();

  return (
    <LoginLayout backButton backDestination={LOGIN_NAVIGATION_MAP.WELCOME}>
      <LoginCard className={LOGIN_CARD.CLASS_NAME} backgroundColor={LOGIN_CARD.BACKGROUND}>
        <Heading title={t(HEADING.TITLE)} className={HEADING.CLASS_NAME} testId={`${AUTOMATION_TEST_ID}__need-help__title`} />
        <Heading
          title={t(TEXT.TITLE)}
          className={TEXT.CLASS_NAME}
          testId={`${AUTOMATION_TEST_ID}__need-help__subtitle`}
        />
        <div className='grid'>
          <Heading title={t(GRID.HEADING.TITLE)} className={GRID.HEADING.CLASS_NAME} testId={`${AUTOMATION_TEST_ID}__need-help__steps__title`} />
          <LoginLineDot number={GRID.DOT_1.NUMBER} title={t(GRID.DOT_1.TITLE)} testId={`${AUTOMATION_TEST_ID}__need-help__step-${GRID.DOT_1.NUMBER}`} />
          <LoginLineDot number={GRID.DOT_2.NUMBER} title={t(GRID.DOT_2.TITLE)} testId={`${AUTOMATION_TEST_ID}__need-help__step-${GRID.DOT_2.NUMBER}`} />
          <LoginLineDot number={GRID.DOT_3.NUMBER} title={t(GRID.DOT_3.TITLE)} testId={`${AUTOMATION_TEST_ID}__need-help__step-${GRID.DOT_3.NUMBER}`} />
        </div>
      </LoginCard>
    </LoginLayout>
  );
};

export default Help;
